@if (order) {
  <account-back [link]="'/account/my-orders'"
    class="m-b-9 m-b-7-s m-b-7-m m-t--1 block p-l-2"
  [title]="'Order %' | translate : order.data.number"></account-back>
  <div sizeClass="SM:bg-col-w p-a-5, XL:bg-col-51 p-a-10">
    <div class="c-6-set m-b-0">
      <p class="s1">{{'Status' | translate}}</p>
      <p class="p1 m-t-2">{{order.data.status}}</p>
      <!-- <a class="button m-t-3">Track order</a> -->
    </div>
    <div class="c-6-set m-b-0">
      <p class="s1">{{'Tracking number' | translate}}</p>
      <p class="p1 m-t-2">{{order.data.number}}</p>
    </div>
    @for (item of order.items; track item) {
      <account-order-view-item [orderItem]="item"
      class="block m-t-9"></account-order-view-item>
    }
  </div>
  <div class="m-t-5 flex"
    sizeClass="SM:bg-col-w p-a-5, XL:bg-col-51 p-a-10">
    <div class="c-6-set m-b-0 flex-column flex-justify-between">
      @if (order.shipping) {
        <div
          class="m-b-2">
          <p class="s1">{{'Delivery address' | translate}}</p>
          <!-- <address-long [addressData]="order.shipping.data"
          class="block p1"></address-long> -->
        </div>
      }
      <div>
        <p class="s1">{{'Payed with' | translate}}</p>
        <p class="p1 m-t-2">{{order.data.payment_method.description}}</p>
      </div>
    </div>
    <div class="c-6-set m-b-0 flex-column flex-justify-between">
      @if (order.shipping) {
        <div class="m-b-2"
          >
          <p class="s1">{{'Delivery method' | translate}}</p>
          <p class="p1 m-t-2">{{order.data.shipping_method.description}}</p>
        </div>
      }
      <div>
        <p class="s1">{{'Placed on' | translate}}</p>
        <p class="p1 m-t-2">{{order.data.date | formatDate}}</p>
      </div>
    </div>
  </div>
  <div class="m-t-5"
    sizeClass="SM:bg-col-w p-a-5, XL:bg-col-51 p-a-10">
    @for (total of totals; track total; let first = $first) {
      <p
        [class.m-t-2]="!first"
        [ngClass]="total.isTotal ? 's1' : 'p1' "
        class="flex flex-justify-between">
        <span>{{ total.title | translate }}</span>
        <price [value]="total.value"
        [useFreeLabel]="true"></price>
      </p>
    }
  </div>
}
@if (!order) {
  <account-back [link]="'/account/my-orders'"
    class="m-b-9 m-b-7-s m-b-7-m m-t--1 block p-l-2"
  [title]="'Invalid order'"></account-back>
  <p class="s1">
    {{ 'Requested order does not exist or couldn`t be loaded' | translate }}
  </p>
  <a class="button m-t-5"
  routerLink="/account/my-orders">{{ 'See your orders' | translate }}</a>
}